<template>
	<div>
	<buttonlist @help="help" ref="SetBtn"></buttonlist>
     <el-card class="box-card">
            <div style="display: flex;background: white">
                <div style="width: 50%;text-align: left;display: flex">
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            :action="uploadurl"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList"
                            :limit="1"
                            style="margin-left: 8px"
                    >
                        <el-button slot="trigger" size="mini" type="primary" :disabled="!btn.Import">{{$t('getapi[372]')}}</el-button>
                    </el-upload>
					<el-date-picker v-model="starttime" type="datetime" size="mini" style="width:200px;margin-left: 8px"></el-date-picker>
                </div>
                <div style="width: 50%;text-align: right">
                    <el-button type="primary" size="mini" @click="check">{{$t('getapi[439]')}}</el-button>
					<el-button type="primary" size="mini" @click="checkIncludeSon">{{$t('getapi[9031]')}}</el-button>
                    <el-button type="primary" size="mini" :disabled="!btn.cal" @click="calc">{{$t('getapi[2530]')}}</el-button>
					<el-button type="primary" size="mini" :disabled="!btn.cal" @click="calcIncludeSon">{{$t('getapi[9032]')}}</el-button>
					<el-button type="primary" size="mini" @click="expt">{{$t('getapi[922]')}}</el-button>
                </div>
            </div>
        </el-card>
		<el-tabs :tab-position="'top'" type="" style="margin-top: 0px" @tab-click="selectInfo">
        <el-tab-pane :label="$t('getapi[7094]')" name="0">
				<vxe-table :data="datajson" ref="singleTable" size="mini" :loading="loading" header-cell-class-name="headerclass" :height="tableHeight" stripe border resizable>
					<vxe-table-column  show-footer-overflow v-for="item in returnArray" 
					:key="item.Headen"
					:field="item.Headen"
					:title="item.Headcn"
					width="120px"
					></vxe-table-column>
				</vxe-table>
        </el-tab-pane>
         <el-tab-pane :label="$t('getapi[8753]')" name="1">
				<vxe-table :data="datajsonA" ref="singleTable1" size="mini" :loading="loading" header-cell-class-name="headerclass" :height="tableHeight - 30" stripe border resizable>
					<vxe-table-column  show-footer-overflow v-for="item in returnArrayA" 
					:key="item.Headen"
					:field="item.Headen"
					:title="item.Headcn"
					:align="item.Headcn=='物料编码'||item.Headcn=='物料名称'||item.Headcn=='项目代码'||item.Headcn=='供应商编码'||item.Headcn=='物料版本'?'left':'right'" 
					width="150px"
					></vxe-table-column>
				</vxe-table>
        </el-tab-pane>
        <el-tab-pane :label="$t('getapi[97]')" name="2">
			<vxe-table :data="datajsonB" ref="singleTable2" size="mini" :loading="loading"  :height="tableHeight - 30" stripe border resizable>
					<vxe-table-column  show-footer-overflow v-for="item in returnArrayB" 
					:key="item.Headen"
					:field="item.Headen"
					:title="item.Headcn"
					:align="item.Headcn=='物料编码'||item.Headcn=='物料名称'||item.Headcn=='项目代码'||item.Headcn=='供应商编码'||item.Headcn=='物料版本'?'left':'right'" 
					width="150px"
					></vxe-table-column>
				</vxe-table>
				
        </el-tab-pane> 
		<el-tab-pane :label="$t('getapi[8754]')" name="3">
			<el-card class="box-card">
            <div style="display: flex;background: white">
                <div style="width: 50%;text-align: left;display: flex">
                    <el-button type="primary" size="mini" @click="selectall">{{$t('getapi[4488]')}}</el-button>
                    <el-button type="primary" size="mini" @click="change">{{$t('getapi[6023]')}}</el-button>
                </div>
            </div>
        </el-card>		
			<vxe-table :data="datajsonC"  ref="xPurTable" size="mini" :loading="loading"  :height="tableHeight - 30" stripe border resizable>
				<vxe-column type="checkbox" width="40"></vxe-column>
				<vxe-table-column  show-footer-overflow v-for="item in returnArrayC"
				:key="item.Headen"
				:field="item.Headen"
				:title="item.Headcn"
				:align="item.Headcn=='物料编码'||item.Headcn=='物料名称'||item.Headcn=='项目代码'||item.Headcn=='供应商编码'||item.Headcn=='物料版本'?'left':'right'"
				width="150px"
				></vxe-table-column>
			</vxe-table>
        </el-tab-pane> 
			
			
			
		</el-tabs>
		<el-dialog v-dialogDrag :visible.sync="visReplace" :title="$t('getapi[8755]')" width="20%" :close-on-click-modal="false" >
        <div class="box" style="height: 120px;margin-top:5px">
        <div class="bbl">
        <span>{{$t('getapi[1480]')}}</span>
        <el-input type="txt" size="mini" style="width: 200px;" v-model="planorder.planno" ></el-input>

        </div>
        <div class="bbl">
        <span>{{$t('getapi[1479]')}}</span>
		<el-input type="text"  class="mcolor" size="mini" style="width: 200px;" v-model="planorder.item_code" readonly>
		<i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectproject"></i>
		</el-input>
        </div>

        <div style="text-align:center;margin-top:20px">
			<el-button size="mini" @click="visReplace = false">{{ $t('getapi[2054]') }}</el-button>
        <el-button type="primary" size="mini"  @click="confirmtrans">{{$t('getapi[1146]')}}</el-button>
        </div>

        </div>


        </el-dialog>
		<!--选择项目-->
		<selector :isVisible="false" :selectType="0" :isBatch=false :isSplitPage=true
                  :postUrl="'/Pur/Requisition/GetSimulationItemPopupList'" @callback="getproject" ref="project"></selector>
	</div>
	
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
import CommonHeader from '@/components/CommonHeader';
export default {
	name:'packplan',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight-190
        }
    },
	data() {
		return {
			visReplace:false,
			fileList: [],
			ids: '',
			showloading: '',
			DbTbNames: '', //表名
			datajson: [],
			datajsonA: [],
			datajsonB: [],
			datajsonC: [],
			datajsonremark: [],
			datajsonliu: [],
			returnArray:[],
			returnArrayA:[],
			returnArrayB:[],
			returnArrayC:[],
			loading: false, // 主表加载状态
			uploadurl: '',
			uploadurlremark: '',
			uploadurlliu: '',
			drolist: [],
			drolistliu: [],
			drosele: 0,
			droseleliu: 0,
			total1: 0,
			returnURL:'',
			excelURL:'',
			excelURLA:'',
			excelURLB:'',
			excelURLC:'',
			selectIndex:'0',
			planorder:{
			planno: "",
			item_code: "",
			List: []
			},
			btn:{
			//计算
			cal:false,
			//添加
			Add:true,
			//移除
			Remove:false,
			//导入
			Import:true
			},
            starttime: '',
            scrollTop:0,
            scrollTop1:0,
			scrollTop2:0,
            scrollTop3:0,
		};
	},
	create() {},
	beforeMount() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		let token = JSON.parse(that.userData).token;
		that.uploadurl = Common.Url + '/Pur/Requisition/PackageMaterialPlanImportUpFile?token=' + token;
		this.btnauthority();
	},
	mounted() {
		console.log('mounted');
		this.authority()
		this.btnauthority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
            that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop1 = res.target.scrollTop
            },false)
            that.$refs.singleTable2.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop2 = res.target.scrollTop
            },false)
            that.$refs.xPurTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop3 = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                this.$refs.singleTable2.bodyWrapper.scrollTop =this.scrollTop2;
                this.$refs.xPurTable.bodyWrapper.scrollTop =this.scrollTop3;
            }, 13)
        })
    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6549]"),this.$t("getapi[16]"));
        },
        authority(){
            let that = this
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetButtonEnable('');
		},
		btnauthority() {
			let that = this;
			//工时
			that.btn.Manhour=false;
			//备注
			that.btn.Notes=false;

			if(that.$limits.authority('plv3', 38, 1) >0){
				//工时
				that.btn.Manhour=true;
				//备注
				that.btn.Notes=true;
			}
			
		},
		selectInfo(tab, event) {
			let that = this;
			that.selectIndex = tab.name;
		},
		selectall(){

		},
		fun2(){

		},

		// item_code: "BRS-07"
		// jieyu: -147
		// on_qty: 12
		// part_code: "0021-25919-P"
		// part_name: "SHIM， LONG， FFU TO FRAME， 5.3"
		// part_version: "003"
		// qty: 125
		// receive_date: "2021-06-09 00:00:00"
		// ship_date: "2021-05-30 00:00:00"
		// stock_qty: 81
		// vender_code: "4AI"
		// xuqiu: 240
		// _XID: "row_75"
		confirmtrans(){
			let that = this;
			if(that.$limits.fnIsEmpty(that.planorder.planno)){
			this.$message.warning(that.$t('getapi[1533]'));//"计划标识不能为空!"
			return;
			}
			let posturl = '/Pur/Requisition/PackageMaterialToPlan';
			that.planorder.List=[];
			let selectRecords = this.$refs.xPurTable.getCheckboxRecords();
			for(let i=0;i<selectRecords.length;i++){
				let obj = {
					part_code: selectRecords[i].part_code,
					part_version: selectRecords[i].part_version,
					qty: selectRecords[i].qty,
					ship_date: selectRecords[i].ship_date,
					receive_date: selectRecords[i].receive_date,
					vender_code: selectRecords[i].vender_code
				}
				that.planorder.List.push(obj);
			}
			that.planorder.LangType = that.$processdata.getLang(),
			that.$http.urlpost(posturl, that.planorder, function(res) {
			if (res.Success == 1) {
                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
			}
			that.visReplace = false;
			});
			
		},
		selectproject() {
		let that = this;
		that.$refs.project.clearInput(true);
		},
		getproject(data){
			let that = this;
			that.planorder.item_code = data.item_code
		},
		change () {
			let that = this;
			let selectRecords = this.$refs.xPurTable.getCheckboxRecords();
			if(selectRecords.length==0){
			this.$message.warning(that.$t('getapi[8756]'));//"请选择一行数据!"
			return;
		}
		//弹窗
		console.log("选择数据:"+JSON.stringify(selectRecords));
		that.visReplace = true;

		//console.log(selectRecords);
		},
		expt(){
			let that = this;
			if(that.selectIndex=='0'){
				if(that.datajson.length>0){
				let hrefurl = Common.Url + that.excelURL;
				window.open(hrefurl);
				}else{
				this.$message.warning(that.$t('getapi[8757]'));//"暂无数据可导出!"
				}
			}
			else if(that.selectIndex=='1'){
			if(that.datajsonA.length>0){
			let hrefurl = Common.Url + that.excelURLA;
			window.open(hrefurl);
			}else{
			this.$message.warning(that.$t('getapi[8757]'));//"暂无数据可导出!"
			}
			}else if(that.selectIndex=='2'){
			if(that.datajsonB.length>0){
			let hrefurl = Common.Url + that.excelURLB;
			window.open(hrefurl);
			}else{
			this.$message.warning(that.$t('getapi[8757]'));//"暂无数据可导出!"
			}
			}else{
				this.$message.warning(that.$t('getapi[8758]'));//"禁止导出!"
			}
		},
		//校验1
		check(){
			let that = this;
			that.loading = true;
			if (that.datajson.length<= 0)
            {
                this.$message.warning(that.$t('getapi[8759]'));//"请首先添加原始数据！"
                return;
			}

			let data ={
			"filepath": that.returnURL,
                StartTime: that.starttime
			};
			that.btn.cal = false;
			let token = JSON.parse(that.userData).token;
			let posturl = '/Pur/Requisition/PackageMaterialPlanCheck';
			that.$http.urlpost(posturl, data, function(res) {
			if (res.Success == 1) {
				that.btn.cal = true;
				that.datajson = res.DataContent.dt;
				that.returnArray = res.DataContent.TbHeader;
				that.excelURL =  res.DataContent.execlpath;
                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
			}else if (res.Success == 2) {
				that.datajson = res.DataContent.dt;
				that.returnArray = res.DataContent.TbHeader;
				that.excelURL =  res.DataContent.execlpath;
                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
			}
			that.loading = false;
			});
		},
        checkIncludeSon(){
            let that = this;
            that.loading = true;
            if (that.datajson.length<= 0)
            {
                this.$message.warning(that.$t('getapi[8759]'));//"请首先添加原始数据！"
                return;
            }

            let data ={
                "filepath": that.returnURL,
                StartTime: that.starttime
            };
            that.btn.cal = false;
            let token = JSON.parse(that.userData).token;
            let posturl = '/Pur/Requisition/PackageMaterialPlanCheck3';
            that.$http.urlpost(posturl, data, function(res) {
                if (res.Success == 1) {
                    that.btn.cal = true;
                    that.datajson = res.DataContent.dt;
                    that.returnArray = res.DataContent.TbHeader;
                    that.excelURL =  res.DataContent.execlpath;
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                }else if (res.Success == 2) {
                    that.datajson = res.DataContent.dt;
                    that.returnArray = res.DataContent.TbHeader;
                    that.excelURL =  res.DataContent.execlpath;
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                }
                that.loading = false;
            });
		},
		//cal
		calc(){
			let that = this;
			if (that.datajson.length<= 0)
            {
                this.$message.warning(that.$t('getapi[8759]'));//"请首先添加原始数据！"
                return;
			}
			that.loading = true;
			let data ={
			"filepath": that.returnURL,
                StartTime: that.starttime
			};
			let token = JSON.parse(that.userData).token;
			let posturl = '/Pur/Requisition/PackageMaterialPlanCalc';
			that.$http.urlpost(posturl, data, function(res) {
			if (res.Success == 1) {
				that.datajsonA = res.DataContent.dtlack;	
				that.datajsonB = res.DataContent.dtplan;	
				that.datajsonC = res.DataContent.dtplanlist;
				// for(let i=0;i<that.datajsonB.length;i++){
				// 	that.datajsonB[i].modify_time =that.$limits.getDateType(that.datajsonB[i].modify_time);
				// }
				that.returnArrayA = res.DataContent.lackheader;
				that.returnArrayB = res.DataContent.planheader;
				that.returnArrayC =  res.DataContent.planlistheader
				that.excelURLA = res.DataContent.lackpath;
				that.excelURLB = res.DataContent.planpath;
				that.$message.success(that.$t('getapi[6431]'));	//"计算完成"
			}
			that.loading = false;
			});
		},
        calcIncludeSon(){
            let that = this;
            if (that.datajson.length<= 0)
            {
                this.$message.warning(that.$t('getapi[8759]'));//"请首先添加原始数据！"
                return;
            }
            that.loading = true;
            let data ={
                "filepath": that.returnURL,
                StartTime: that.starttime
            };
            let token = JSON.parse(that.userData).token;
            let posturl = '/Pur/Requisition/PackageMaterialPlanCalc3';
            that.$http.urlpost(posturl, data, function(res) {
                if (res.Success == 1) {
                    that.datajsonA = res.DataContent.dtlack;
                    that.datajsonB = res.DataContent.dtplan;
                    that.datajsonC = res.DataContent.dtplanlist;
                    // for(let i=0;i<that.datajsonB.length;i++){
                    // 	that.datajsonB[i].modify_time =that.$limits.getDateType(that.datajsonB[i].modify_time);
                    // }
                    that.returnArrayA = res.DataContent.lackheader;
                    that.returnArrayB = res.DataContent.planheader;
                    that.returnArrayC =  res.DataContent.planlistheader
                    that.excelURLA = res.DataContent.lackpath;
                    that.excelURLB = res.DataContent.planpath;
                    that.$message.success(that.$t('getapi[6431]'));	//"计算完成"
                }
                that.loading = false;
            });
        },
		//删除行
		delline(e) {
			console.log(e);
			let line = e.$rowIndex;
			if (line >= 0) {
				this.datajson.splice(line, 1);
			} else {
				this.$message.error(this.$t('getapi[8710]'));//'移除失败'
			}
		},
		dellines(e) {
			let line = e.$rowIndex;
			if (line >= 0) {
				this.datajsonremark.splice(line, 1);
			} else {
				this.$message.error(this.$t('getapi[8710]'));//'移除失败'
			}
		},
		dellineliu(e) {
			let line = e.$rowIndex;
			if (line >= 0) {
				this.datajsonliu.splice(line, 1);
			} else {
				this.$message.error(this.$t('getapi[8710]'));//'移除失败'
			}
		},

		handleSelectionChange(val) {
			let that = this;
			that.selectIDData = '';
			for (let i = 0; i < val.length; i++) {
				that.selectIDData += val[i].Exclusively_Id + ',';
			}
			console.log(that.selectIDData);
		},


		handleChange(file, fileList) {
			let that = this;
			that.loading = true;
			console.log(file);
			if (file.response) {
				let response = file.response.Success;
				if (response == 0) {
					that.$message.error(file.response.Msg);
				} else {
					that.datajson = file.response.DataContent.dt;
				}
				that.loading = false;
			}
		},
		handleSuccess(res, file, fileList) {
			let that = this;
			console.log(res);
			let response = res.Success;
			if (response == 0) {
                that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
			} else {
				//that.datajson = res.DataContent;
				that.returnArray = res.DataContent.TbHeader;
				that.returnURL = res.DataContent.URL;
				that.excelURL =res.DataContent.execlpath;
				that.datajson = res.DataContent.dt;
			}
			that.fileList=[];
			that.loading = false;
		},
		handleError(err, file, fileList) {
			let that = this;
			that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
			that.loading = false;
		},
		handleChangeremark(file, fileList) {
			let that = this;
			console.log(file);
			if (file.response) {
				let response = file.response.Success;
				if (response == 0) {
					that.$message.error(file.response.Msg);
				} else {
					that.datajsonremark = file.response.DataContent;
				}
			}
		},
		handleSuccessremark(res, file, fileList) {
			let that = this;
			console.log(res);
			let response = res.Success;
			if (response == 0) {
                that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
			} else {
				that.datajsonremark = res.DataContent;
			}
		},
		handleErrorremark(err, file, fileList) {
			let that = this;
			that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
		},
		handleChangeliu(file, fileList) {
			let that = this;
			console.log(file);
			if (file.response) {
				let response = file.response.Success;
				if (response == 0) {
					that.$message.error(file.response.Msg);
				} else {
					that.datajsonliu = file.response.DataContent;
				}
			}
		},
		handleSuccessliu(res, file, fileList) {
			let that = this;
			console.log(res);
			let response = res.Success;
			if (response == 0) {
                that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
			} else {
				that.datajsonliu = res.DataContent;
			}
			that.fileList=[];
			
		},
		handleRemove(file, fileList) {
			console.log(file, fileList);
		},
		handlePreview(file) {
			console.log("handlePreview"+file);
		},
		// 保存数据
		okbtn() {
			let that = this;
			that.loading = true;
			let parm = {
				SaveType: that.drosele,
                LangType: that.$processdata.getLang(),
				List: []
			};
			parm.List = that.datajson;
			console.log(JSON.stringify(parm));
			that.$http.urlpost('Eng/Routings/RWHoursSave', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[818]'));
				}
				that.loading = false;
			});
		},
		// 保存备注数据
		okbtns() {
			let that = this;
			that.loading = true;
			let parm = that.datajsonremark;
			console.log(JSON.stringify(parm));
			that.$http.urlpost('Eng/Routings/RoutRemarkSave', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[818]'));
				}
				that.loading = false;
			});
		},
		// 保存流转方向数据
		okbtnliu() {
			let that = this;
			if(that.droseleliu==4){
				that.loading = true;
				let parm = that.datajsonliu;
				console.log(JSON.stringify(parm));
				that.$http.urlpost('Eng/Routings/RoutRemarkSave', parm, function(res) {
				if (res.Success == 1) {
				that.$message.success(that.$t('getapi[818]'));
				}
				that.loading = false;
				});
			}else if(that.droseleliu==3){
				that.loading = true;
				let parm = {
				SaveType: that.droseleliu,
				List: []
				};
				parm.List = that.datajsonliu;
				console.log(JSON.stringify(parm));
				that.$http.urlpost('Eng/Routings/RoutMoveSave', parm, function(res) {
				if (res.Success == 1) {
				that.$message.success(that.$t('getapi[818]'));
				}
				that.loading = false;
				});
			}else{

				that.$message.warning(that.$t('getapi[8625]'));//'请选择更新字段'
			}
		}
	}
};
</script>

<style scoped lang="less">
span.title {
	width: 100%;
	display: flex;
	height: 40px;
	line-height: 40px;
}

span.title .el-switch {
	display: inline-block;
	margin: 8px 30px;
}
.box {
	width: 100%;
	overflow-x: auto;
	.bbl {
		margin: 0px auto 10px;
		white-space: pre;
		span {
			margin-left: 10px;
			min-width: 70px;
			text-align: left;
			line-height: 20px;
			display: inline-block;
			margin-right: 0px;
		}
	}
}


    /deep/ .green {
        background: #c8ffbb;
    }
    /deep/ .red {
        background: #ff7879;
    }
</style>
